module.exports = __webpack_public_path__ + "static/media/dot-check.1741447e.png";